import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { IWorkflowStep } from '@modules/admin/AdminTools/Workflows/types';
import { withQueryParams } from '@shared/commonFunctions';
import { DealUserTypeEnum } from '@modules/ContactManager/components/Tabs/components/Deals/interfaces';
import { IDealMoveImportResponse } from '../shared/interfaces';

const STEP_PATH = `/${SERVICES.WORKFLOW}/steps`;

export const requestGetWorkflowStepsByWorkflowId = (workflowId: string) => {
	const url = `${STEP_PATH}/byworkflow/${workflowId}`;

	return mutate(url, async() => {
		try {
			const response = await axios.get<IWorkflowStep[]>(url);

			return response.data;
		} catch (err) {
			Notistack.generalError(getError(err));
		}
	});
};

export const requestWorkFlowStepDealMoveImport = async(file: File, workflowStepId: string) => {
	const url = `${SERVICES.DEAL}/DealMoveImport?StepId=${workflowStepId}&DealMoveImportType=1`;
	const formData = new FormData();
	formData.append('files', file);

	try {
		const config = {
			headers: {
				'content-type': 'multipart/form-data',
			},
		};

		const response = await axios.post<IDealMoveImportResponse[]>(url, formData, config);
		return response.data;
	} catch (err) {
		Notistack.generalError(getError(err));
	}
};

export const requestBulkDealUserUpdateMoveImport = async(file: File, DealUserType: DealUserTypeEnum, UserId: string, UserName: string) => {
	const url = withQueryParams(`${SERVICES.DEAL}/DealMoveImport/bulkdealuserupdate`, { DealUserType, UserId, UserName });
	const formData = new FormData();
	formData.append('files', file);

	try {
		const config = {
			headers: {
				'content-type': 'multipart/form-data',
			},
		};

		const response = await axios.post<IDealMoveImportResponse[]>(url, formData, config);
		return response.data;
	} catch (err) {
		Notistack.generalError(getError(err));
	}
};